export default "__VITE_ASSET__b44b36bc__"